import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-04c32b55"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "form-box cms-card-block"
};
const _hoisted_2 = {
  class: "search__btn"
};
import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { getSysDictListApi } from '@/api/live';
import { testBalanceApi, getAaaOptionApi } from '@/api/traceDebug';
import { useCommon } from '@/store/useCommon';
import { ElMessage } from 'element-plus';
import { getAppStyleOptionsApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'searchHeader',
  props: {
    modelValue: {
      type: Object,
      default: () => {}
    },
    isShowBtns: {
      type: Boolean,
      default: true
    },
    ismForm: {
      type: Boolean,
      default: false
    },
    isInline: {
      type: Boolean,
      default: true
    },
    globalWidth: {
      type: String,
      default: '300px' // 300px

    },
    // 表单校验对象
    formRules: {
      type: Object,
      default: () => ({})
    },
    // labe默认长度
    labelWidth: {
      type: String,
      default: '120px' // 120px

    },
    // 表单列表
    formList: {
      type: Array,
      default: () => [] // default: [],

    },
    size: {
      type: Object,
      default: {
        sm: 24,
        md: {},
        lg: 12,
        xl: 8,
        xs: {}
      }
    },
    gutter: {
      type: Number,
      default: 130
    }
  },
  emits: ['update:modelValue', 'login', 'reset', 'updateInformation', 'loading'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const sn = ref('');
    const loginType = ref(0);
    const store = useCommon();
    const loginOPtion = [{
      value: 0,
      label: 'SN'
    }, {
      value: 1,
      label: 'User'
    }, {
      value: 2,
      label: 'Activation code'
    }];
    const IotOption = [{
      value: 0,
      label: 'NO'
    }, {
      value: 1,
      label: 'YES'
    }];
    const clientTypeOption = ref([]);
    const aaaOption = ref();
    const appOptions = ref();
    onMounted(() => {
      getSysDictList('client_type');
      getAaaOption();
      getAppStyleOptions();
    });
    watch(() => props.modelValue, (newVal, oldVal) => {
      //监听变化，更新双向绑定
      emit('update:modelValue', newVal);
    }, {
      deep: true,
      immediate: true
    });
    watch(() => props.modelValue.loginType, (newVal, oldVal) => {
      // 监听登录方式的改变
      // Login Type为SN：Client Type为EcosStb, Iot为NO
      // Login Type为User: Client Type为AndroidStb，Iot为YES
      // Login Type为Activation code，Client Type为AndroidStb，Iot为YES
      switch (newVal) {
        case 0:
          props.modelValue.iotFlag = 0;
          props.modelValue.clientType = 'EcosStb';
          break;

        case 1:
          props.modelValue.iotFlag = 1;
          props.modelValue.clientType = 'AndroidStb';
          break;

        case 2:
          props.modelValue.iotFlag = 1;
          props.modelValue.clientType = 'AndroidStb';
          break;
      }
    }, {
      deep: true,
      immediate: true
    });

    const focusMethods = () => {
      console.log('focus');
    }; // 抛出搜索按钮事件


    const login = () => {
      emit('login', props.modelValue);
    }; // 抛出重置按钮事件


    const reset = () => {
      emit('reset');
    }; // 字典


    const getSysDictList = async type => {
      const {
        code,
        data
      } = await getSysDictListApi(type);

      if (code === '0') {
        switch (type) {
          case 'client_type':
            clientTypeOption.value = data;
            break;
        }
      }
    }; // 调用balance接口拿到登录用的域名和端口


    const getLoginPort = async val => {
      // 触发父组件loading
      emit('loading', true);

      try {
        const {
          returnCode,
          aaadomain,
          aaaport
        } = await testBalanceApi(val);
        emit('updateInformation', aaadomain, aaaport);
        store.addTraceDebugUrl(`https://${aaadomain}:${aaaport}`);
      } catch (error) {
        console.log('272error', error);
        ElMessage({
          type: 'error',
          message: error.message
        });
      }

      emit('loading', false);
    }; // 监听用户名input事件，限制未选择balance的情况


    const onInputUser = val => {
      if (props.modelValue.aaaServer.length === 0) {
        props.modelValue.username = '';
        return ElMessage({
          type: 'error',
          message: t('请先选择aaa')
        });
      }
    }; // 获取aaa的选项


    const getAaaOption = async () => {
      const res = await getAaaOptionApi('https://newvlist.com/balance/serverInfo/list?groupName=0151a5b3-b409-40d0-a625-86045f9521d9');

      if (res && res.length > 0) {
        aaaOption.value = res.map(item => {
          return { ...item,
            value: item.protocol + '://' + item.ip + ':' + item.port
          };
        }); //默认选中第一个服务器

        if (res && res.length > 0) {
          props.modelValue.aaaServer = aaaOption.value[0].value;
          onServerChange(aaaOption.value[0].value);
        }
      } else {
        ElMessage({
          type: 'error',
          message: t('获取aaa异常')
        });
      }
    };

    const onServerChange = val => {
      let aaadomain = val.split(':')[1].substr(2);
      let aaaport = val.split(':')[2];
      emit('updateInformation', aaadomain, aaaport);
      localStorage.setItem('balanceUrl', val);
      store.addTraceDebugUrl(val);
    }; // app风格选项


    const getAppStyleOptions = async () => {
      const {
        code,
        data
      } = await getAppStyleOptionsApi();

      if (code == 0) {
        appOptions.value = data;
      }
    };

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        model: _ctx.formData,
        "label-width": __props.labelWidth,
        rules: __props.formRules,
        ref: "mForm",
        class: "search-form",
        inline: __props.isInline
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: __props.gutter
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "aaa",
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.modelValue.aaaServer,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.modelValue.aaaServer = $event),
                style: {
                  "width": "100%"
                },
                onChange: onServerChange
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aaaOption.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.name,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"]), _createVNode(_component_el_col, {
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: _ctx.$t('登录方式'),
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.modelValue.loginType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => __props.modelValue.loginType = $event),
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(loginOPtion, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"]), _createVNode(_component_el_col, {
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: _ctx.$t('客户端类型'),
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.modelValue.clientType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => __props.modelValue.clientType = $event),
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientTypeOption.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.label
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"]), _createVNode(_component_el_col, {
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "App Version",
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.modelValue.appversion,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => __props.modelValue.appversion = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"])]),
          _: 1
        }, 8, ["gutter"]), _createVNode(_component_el_row, {
          gutter: __props.gutter
        }, {
          default: _withCtx(() => [__props.modelValue.loginType === 0 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "SN",
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.modelValue.sn,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => __props.modelValue.sn = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"])) : _createCommentVNode("", true), __props.modelValue.loginType === 1 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 1,
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: _ctx.$t('用户名'),
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.modelValue.username,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => __props.modelValue.username = $event),
                onInput: onInputUser
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"])) : _createCommentVNode("", true), __props.modelValue.loginType === 1 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 2,
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: _ctx.$t('密码'),
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.modelValue.password,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => __props.modelValue.password = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"])) : _createCommentVNode("", true), __props.modelValue.loginType === 2 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 3,
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "Activation Code",
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.modelValue.activationCode,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => __props.modelValue.activationCode = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"])) : _createCommentVNode("", true), _createVNode(_component_el_col, {
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "Iot",
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.modelValue.iotFlag,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => __props.modelValue.iotFlag = $event),
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(IotOption, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"]), __props.modelValue.loginType === 0 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 4,
            span: 6,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: _ctx.$t('APP风格'),
              style: {
                "width": "102%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.modelValue.appStyle,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => __props.modelValue.appStyle = $event),
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appOptions.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["sm", "md", "lg", "xl", "xs"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["gutter"]), _createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [__props.isShowBtns ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs,
            style: {
              "margin-left": "auto"
            }
          }, {
            default: _withCtx(() => [_renderSlot(_ctx.$slots, "searchItem", {}, () => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
              class: "cms-op-btn cms-op-btn-main",
              onClick: login
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('登录')), 1)]),
              _: 1
            }), _createVNode(_component_el_button, {
              class: "cms-op-btn cms-op-btn-main cms-op-btn-non-focus",
              onClick: reset
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('重置')), 1)]),
              _: 1
            })])])]),
            _: 3
          }, 8, ["sm", "md", "lg", "xl", "xs"])) : _createCommentVNode("", true)]),
          _: 3
        })]),
        _: 3
      }, 8, ["model", "label-width", "rules", "inline"])])), [[_directive_loading, _ctx.loading]]);
    };
  }

});